import React from "react";
import "./App.css";

function PrivacyPolicy() {
  return (
    <div className="privacyApp">
      <section className="privacy">
        <h1>Privacy Policy for ITP Western Express</h1>
        <h3>1. Introduction</h3>
        <p>
          ITP Western Express ("we", "our", or "us") values the privacy of our
          customers and associates (employees or clients) and is committed to
          protecting personal information. This Privacy Policy explains how we
          collect, use, disclose, and safeguard your information when you visit
          our website{" "}
          <a
            href="https://itpwexp.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://itpwexp.com/
          </a>
          , use our mobile application, and engage with our services and
          advertisements.
        </p>

        <h3>2. Information Collection</h3>
        <h4>2.1. Personal Information</h4>
        <p>
          You may be asked to provide personal information when using our
          services, including but not limited to:
        </p>
        <ul>
          <li>Name</li>
          <li>Address</li>
          <li>Contact information (name, email, phone)</li>
        </ul>
        <h4>2.2. Non-Personal Information</h4>
        <p>
          We automatically collect certain information when you visit, use, or
          navigate our services. This information does not reveal your specific
          identity but may include:
        </p>
        <ul>
          <li>IP address</li>
          <li>Operating system</li>
          <li>Language preferences</li>
          <li>Date and time of access</li>
          <li>Device and Usage Information</li>
          <li>URLs of referring/exit pages</li>
          <li>Browser and device characteristics</li>
        </ul>

        <h3>3. Use of Information</h3>
        <p>The information we collect from you may be used to:</p>
        <ul>
          <li>Provide, operate, and maintain our services</li>
          <li>Improve, personalize, and expand our services</li>
          <li>Understand and analyze how you use our services</li>
          <li>Develop new services, features, and functionality</li>
          <li>
            Communicate with you, either directly or through one of our
            partners, including for customer service, to provide you with
            updates and other information relating to the website, and for
            marketing and promotional purposes
          </li>
          <li>Send you emails</li>
          <li>Find and prevent fraud</li>
        </ul>

        <h3>4. Disclosure of Information</h3>
        <p>
          We may share information we have collected about you in certain
          situations. Your information may be disclosed as follows:
        </p>
        <ul>
          <li>
            To service providers and others who help with our business
            operations and assist in the delivery of our services
          </li>
          <li>
            To third parties to whom you or your agents authorize us to disclose
            your personal information in connection with products or services we
            provide to you
          </li>
        </ul>

        <h3>5. Security of Your Information</h3>
        <p>
          We use administrative, technical, and physical security measures to
          help protect your personal information. While we have taken reasonable
          steps to secure the personal information you provide to us, please be
          aware that despite our efforts, no security measures are perfect or
          impenetrable, and no method of data transmission can be guaranteed
          against any interception or other type of misuse.
        </p>

        <h3>6. Cookies and Similar Technologies</h3>
        <p>
          We use cookies and similar tracking technologies (like web beacons and
          pixels) to access or store information. Specific information about how
          we use such technologies and how you can refuse certain cookies is set
          out in our Cookie Policy.
        </p>

        <h3>7. Privacy Rights</h3>
        <p>
          Depending on your location (state, country), you may have certain
          rights regarding the personal information we hold about you. These may
          include the right to:
        </p>
        <ul>
          <li>Request deletion of your personal information</li>
          <li>Opt-out of the sale of personal information</li>
          <li>Request access to the personal information we hold about you</li>
          <li>
            Request correction of the personal information that is wrong or
            incomplete
          </li>
          <li>
            Withdraw consent at any time where we rely on consent to process
            your personal information
          </li>
        </ul>

        <h3>8. Updates to This Policy</h3>
        <p>
          We may update this Privacy Policy from time to time in response to
          changing legal, technical, or business developments. When we update
          our Privacy Policy, we will take appropriate measures to inform you,
          consistent with the significance of the changes we make.
        </p>

        <h3>9. Contact Us</h3>
        <p>
          If you have any questions or concerns about this Privacy Policy,
          please contact us at:
          <a href="mailto:support@apply-itpwexp.com">support@itpwexp.com</a>.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
